import { isImmutable,Record } from "immutable";
import { isNil } from "lodash";

import createFromJS from "../../createFromJS";

export const FlatRectRecord = Record({
  left: 0,
  right: 0,
  bottom: 0,
  top: 0,
  width: 0,
  height: 0
});

createFromJS.registerCallback("FlatRectRecord", any => {
  let { left, right, bottom, top, width, height } = isImmutable(any) ? any.toObject() : any;
  if (isNil(width)) {
    width = right - left;
  }
  if (isNil(right)) {
    right = left + width;
  }
  if (isNil(left)) {
    left = right - width;
  }
  if (isNil(height)) {
    height = bottom - top;
  }
  if (isNil(bottom)) {
    bottom = top + height;
  }
  if (isNil(top)) {
    top = bottom - height;
  }
  return FlatRectRecord({ left, right, top, bottom, width, height });
});
